module.exports = __webpack_public_path__ + "static/media/terje.95dcb3a6.png";